import template from './description-mouvement.html'
import css from './description-mouvement.css'
import { DescriptionMouvementController } from './description-mouvement.controller.js'

export const DescriptionMouvementComponent = {
  template: template,
  controller: DescriptionMouvementController,
  controllerAs: 'DescriptionMouvementController',
  require: {
	parentMouvement: '^^mouvement',
	parentSimulator: '^^simulatorComponent'
  },
  
  bindings: {
    resource: '='
  }
}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/description-mouvement/description-mouvement.component.js